import { IControl, EControlTypes } from '../helpers';

export const DEFAULT_CONTROL:IControl = {
    ComponentId: '',
    ControlId: '',
    OutputValues: [{
        Id: '0',
        LogicalName: '',
        Name: 'Textbox',
        Type: 0,
        IsRequiredGlobalOutput: false,
        DisablePrepopulatedValue: false
    }],
    ControlType: {
        NameType: 'Textbox',
        OutputValueType: EControlTypes.textbox
    },
    Properties: []
};

export const NON_REPEATABLE_CONTROL_TYPES: string[] = ["ESRI Map", "File Upload", "Google Map", "Booking"];

export const DEFAULT_VALIDATION_RULE_CONFIG = {"Config":{"condition":"AND","rules":[{"id":"43f75320-5147-490b-ab0e-294fd5be8422","type":"text","operator":"Equals"}]},"EditorMarkupArray":[]}

export const DEFAULT_CONTENT_EDITABLE_VALUE = JSON.stringify({text: '', markup: '<p></p>'});

export const CONTROL_BLOCK_LOOPING_PROPERTIES = ["Is Repeatable", "Repeatable Group Name", "Number Of Iterations", "Max Iterations"];


// WEBPACK FOOTER //
// ./source/ts/constants/controls.ts